import {AppointmentStatusEnum} from '../../models/appointment';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MealPlanAppointmentResponseDTO} from '../../dtos/meal-plan';

@Component({
  selector: 'app-card-meal-plan-to-appointment',
  templateUrl: './card-meal-plan-to-appointment.component.html',
  styleUrls: ['./card-meal-plan-to-appointment.component.scss']
})
export class CardMealPlanToAppointmentComponent implements OnInit {

  @Input() appointments: MealPlanAppointmentResponseDTO[] = [];
  @Input() appointmentSelectedId: string;
  @Input() showSelection = true;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  appointmentStatus = AppointmentStatusEnum;
  constructor() { }

  ngOnInit(): void {
  }

  select(): void {
    this.selected.emit(this.appointmentSelectedId);
  }
}
